export default {
  header: {
    reserve: 'Rezervuokite vietas',
    finalize: 'Užbaikite rezervaciją'
  },
  home: {
    legend: {
      available: 'Laisva',
      reserved: 'Rezervuota',
      booked: 'Užsakyta'
    },
    summary: {
      selected: 'Pasirinkta {count} vieta | Pasirinktos {count} vietos',
      total: 'Bendra kaina: {price}€',
      clear: '✖ Išvalyti pasirinkimą',
      continue: 'Tęsti →'
    },
    error: {
      title: 'Panašu, kad kažkas buvo greitesnis!',
      message: 'Jūsų pasirinkta vieta buvo rezervuota. Peržiūrėkite kitas galimas vietas.',
      button: 'PASIRINKTI KITĄ VIETĄ'
    }
  },
  booking: {
    heading: 'Rezervacijos informacija',
    back: 'Atgal',
    fields: {
      country: 'Šalis',
      firstName: 'Vardas',
      lastName: 'Pavardė',
      phone: 'Telefono numeris',
      email: 'El. paštas',
      company: 'Įmonės pavadinimas',
      registration: 'Įmonės registracijos numeris',
      description: 'Produkto aprašymas',
      comments: 'Papildomi komentarai',
      commentsOptional: '(nebūtina)',
      vatNumber: 'PVM mokėtojo kodas'
    },
    countries: {
      latvia: 'Latvija',
      lithuania: 'Lietuva',
      estonia: 'Estija',
      other: 'Kita'
    },
    errors: {
      country: 'Prašome pasirinkti savo šalį',
      firstName: 'Prašome įvesti vardą',
      lastName: 'Prašome įvesti pavardę',
      phone: 'Prašome įvesti telefono numerį',
      email: 'Prašome įvesti galiojantį el. pašto adresą',
      company: 'Prašome įvesti įmonės pavadinimą',
      registration: 'Prašome įvesti registracijos numerį',
      description: 'Prašome aprašyti savo produktą',
      terms: 'Prašome sutikti su sąlygomis',
      vatNumber: 'Prašome įvesti savo PVM kodą'
    },
    inboxError: '{domain} el. pašto adresai nepriimami dėl pristatymo problemų. Prašome naudoti kitą adresą.',
    termsLink: 'TAISYKLĖS IR SĄLYGOS',
    termsText: 'Perskaičiau {link} ir su jomis sutinku.',
    vat: {
      text: 'Mano įmonė yra registruota PVM mokėtoja ir turi galiojantį PVM kodą, išduotą Lietuvoje, Estijoje arba kitoje Europos Sąjungos šalyje (<u>!NE Latvijoje!</u>). Todėl šiam sandoriui turėtų būti taikomas atvirkštinio apmokestinimo mechanizmas (0% PVM).',
      hint: 'pvz. EE123456789; LT12345679; LT123456789012',
      footnote: '*PVM direktyva 2006/112/EB 44 str., 196 str.<br> Apmokestinama gavėjo šalyje (PVM).<br> Atvirkštinis apmokestinimas'
    },
    vatLabel: 'PVM',
    total: 'IŠ VISO:',
    confirm: 'Patvirtinti rezervaciją'
  },
  tooltip: {
    status: {
      available: 'Laisva',
      reserved: 'Rezervuota',
      booked: 'Užsakyta'
    },
    dimensions: 'Matmenys: 3x2 m',
    select: 'PASIRINKTI VIETĄ',
    deselect: 'PANAIKINTI PASIRINKIMĄ'
  },
  map: {
    foodCourt: 'MAISTO ZONA IR PARTNERIŲ PROMO ZONA',
    kidsWorkshops: 'VAIKŲ DIRBTUVĖS',
    entrance: 'ĮĖJIMAS',
    gate: 'VARTAI #{n}',
    foodSellers: 'MAISTO PREKEIVIAI',
    kidsInflatables: 'VAIKŲ PRIPUČIAMŲ ATRAKCIONŲ MIESTAS IR',
    partnersPromoZone: 'PARTNERIŲ PROMO ZONA'
  },
  thankyou: {
    heading: 'Ačiū!',
    line1: 'Jūsų vietos (-ų) registracija gauta.',
    line2: 'Netrukus el. paštu gausite sąskaitą ir papildomą informaciją!',
    returnHome: 'Grįžti į pradžią',
    processing: 'Palaukite, generuojama sąskaita…',
    processingStep1: 'Generuojama sąskaita…',
    processingStep2: 'Siunčiamas patvirtinimo el. laiškas…',
    processingNote: 'Prašome neuždaryti šio puslapio.',
    registrationStartsIn: 'Registracija prasideda po',
    days: 'Dienos',
    hours: 'Valandos',
    minutes: 'Minutės',
    seconds: 'Sekundės'
  }
}
